import { TeacherManagementForm } from './TeacherManagementForm';
export default TeacherManagementForm;
